<template>
  <div :class="['showhide-fadeslide', showForm]">
    <form @submit.prevent="submitEmail" data-vv-scope="forgotpass-form">
      <div class="row">
        <div class="small-12 columns">
          <a href="javascript:;" class="sign-in-link" v-on:click="goBack">
            <icon name="chevron-left" class="margin-r-xs"></icon>
            {{ $t('customerForm.signIn') }}
          </a>
        </div>
      </div>

      <div class="row">
        <div class="small-12 columns">
          <div :class="['alert margin-v-s', formMessageStatus]" v-if="showFormMessage">
            {{ flashData.message }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="small-12 columns">
          <div :class="{'showhide-fadeslide':true, 'hide':(formMessageStatus === 'success')}">
            <div :class="isSafari">
              <p class="body-text">{{ $t('customerForm.enterEmail') }}</p>

              <div :class="{'field-group':true, 'field-error': error.email}">
                <label class="field-label">{{ $t('common.email') }}</label>
                <input type="text" name="email" placeholder="johndoe@gmail.com"
                  class="field-text" v-model="email" ref="forgotEmail" />
                <span v-show="error.email" class="field-error-message">{{ error.email }}</span>
              </div>

              <div class="row">
                <div class="medium-6 columns medium-offset-6 text-right">
                  <button type="submit" v-bind:class="['op-btn btn-lg btn-block', (resendPinIsLoading ? 'loading' : '')]">
                    <span class="original-label">{{ $t('customerForm.sendReset') }}</span>
                    <div class="loaderx">
                      <icon name="refresh" spin class="magin-l-xs"></icon>
                      {{ $t('common.loading') }}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

export default {
  name: 'forgot-password-form',
  props: [ 'showForm', 'flash' ],
  data () {
    return {
      email: '',
      resendPinIsLoading: false,
      formMessage: '',
      formMessageStatus: '',
      showFormMessage: false,
      isSafari: navigator.userAgent.indexOf('Edge') > -1 ? 'safari' : '',
      error: {
        email: ''
      }
    }
  },
  computed: {
    flashData: function () {
      return this.flash
    }
  },
  methods: {
    focusForm: function () {
      this.$refs.forgotEmail.focus()
      this.errors.items = []
    },
    goBack: function () {
      this.$emit('hideForgotPassword')
      this.showFormMessage = false
      this.formMessageStatus = ''
    },
    submitEmail: function () {
      this.error.email = ''
      if (!this.email) {
        this.error.email = this.$t('common.fieldRequired', {email: 'email'})
      }
      let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!pattern.test(this.email)) {
        this.error.email = this.$t('common.invalidEmail')
      }
      if (this.error.email) return

      this.resendPinIsLoading = true
      this.$root.$emit('forgotPassword', { email: this.email })
    }
  },
  created: function () {
    var self = this;
    this.$root.$on('forgotPassResendSuccess', function () {
      self.resendPinIsLoading = false
      self.showFormMessage = true
      self.formMessageStatus = 'success'
    })
    this.$root.$on('forgotPassResendFailure', function (response) {
      self.resendPinIsLoading = false
      self.showFormMessage = true
      self.formMessageStatus = 'error'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/Customer/ForgotPasswordForm.scss";
</style>



// WEBPACK FOOTER //
// ForgotPasswordForm.vue?cf01a9a6